const breadCrumb = "Diário Digital";

const routes = [
  {
    path: "/excecao-horario",
    name: "excecao-horario",
    meta: {
      allowedPermissions: ["instrumento_pedagogico_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ParametrosDiario/ExcecaoHorario/ExcecaoHorarioHome.vue"),
  },
  {
    path: "/excecao-horario-list",
    name: "excecao-horario-list",
    meta: {
      allowedPermissions: ["instrumento_pedagogico_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/ExcecaoHorario/ExcecaoHorarioHomeList.vue"
      ),
  },
  {
    path: "/excecao-horario-edicao/:id",
    name: "excecao-horario-edicao",
    meta: {
      allowedPermissions: ["instrumento_pedagogico_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ParametrosDiario/ExcecaoHorario/ExcecaoHorarioEdit.vue"),
  },
  {
    path: "/excecao-horario-cadastro",
    name: "excecao-horario-cadastro",
    meta: {
      allowedPermissions: ["instrumento_pedagogico_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ParametrosDiario/ExcecaoHorario/ExcecaoHorarioCad.vue"),
  },
];

export default routes;
